// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bho_tr","LeftMenu__link":"ir_b bho_vt bho_a bho_rc","LeftMenu__link__icon":"ir_c"};